import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutFreightGroupItemCompare } from "./autogen/AutogenLayoutFreightGroupItemCompare";
import { FreightGroupItemCompareChangeItem } from "./FreightGroupItemCompareChangeItem";
import { FreightGroupItemCompareItem } from "./FreightGroupItemCompareItem";
import { BaseCompare, TableConfig } from "./BaseCompare";

export class FreightGroupItemCompare extends AutogenLayoutFreightGroupItemCompare {
    private _newOrRemovedFreightGroupItems: any[] = [];
    private _changedFreightGroupItems: any[] = [];
    private baseCompare = new BaseCompare();

    // Delegate properties to baseCompare
    get isOrderUpdateAllowed(): boolean { return this.baseCompare.isOrderUpdateAllowed; }
    set isOrderUpdateAllowed(value: boolean) { this.baseCompare.isOrderUpdateAllowed = value; }

    get newOrRemovedFreightGroupItems(): any[] { return this._newOrRemovedFreightGroupItems; }
    set newOrRemovedFreightGroupItems(value: any[]) { this._newOrRemovedFreightGroupItems = value; }

    get changedFreightGroupItems(): any[] { return this._changedFreightGroupItems; }
    set changedFreightGroupItems(value: any[]) { this._changedFreightGroupItems = value; }

    get isInvoice(): boolean { return this.baseCompare.isInvoice; }
    set isInvoice(value: boolean) { this.baseCompare.isInvoice = value; }

    get isCompareHistory(): boolean { return this.baseCompare.isCompareHistory; }
    set isCompareHistory(value: boolean) { this.baseCompare.isCompareHistory = value; }

    setupTableData(mode: DataSourceMode): void {
        const tableConfigs: TableConfig[] = [
            {
                table: this.tableFreightGroupItemAdd,
                label: this.labelAddsAndDeletes,
                data: this.newOrRemovedFreightGroupItems
            },
            {
                table: this.tableFreightGroupItemChange,
                label: this.labelChanges,
                data: this.changedFreightGroupItems
            }
        ];

        this.baseCompare.setupTableData(tableConfigs, mode);
    }

    onFreightGroupItemAddDeleteRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleAddDeleteRowDisplay(
            event,
            this.newOrRemovedFreightGroupItems,
            FreightGroupItemCompareItem,
            FreightGroupItemCompareChangeItem
        );
    }

    onFreightGroupItemChangeRowDisplay(event: TableRowDisplayEvent): void {
        this.baseCompare.handleChangeRowDisplay(
            event,
            this.changedFreightGroupItems,
            FreightGroupItemCompareItem,
            FreightGroupItemCompareChangeItem
        );
    }
}
